<template>
  <div
    :class="{pulse: checked, checked: checked}"
    class="step-icon"
  >
    <font-awesome-icon
      v-if="checked"
      icon="check"
      class="icon"
    />
    <font-awesome-icon
      v-else
      icon="exclamation"
      class="icon"
    />
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck, faExclamation } from '@fortawesome/free-solid-svg-icons'
library.add(
  faCheck,
  faExclamation
)

export default {
  name: 'step-icon',
  props: {
    checked: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@scss/custom.scss';

.step-icon {
  display: flex;
  z-index: 1;
  padding:.5em;
  border-radius: 100%;
  background-color: var(--main-wine-club-default-step-background);
  transition: ease-in-out background-color .2s;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    path {
      fill: var(--main-warning-badge-text-color);
    }
  }
  &.checked {
    background-color: var(--main-wine-club-success-step-background);
    svg {
      path {
        fill: var(--main-badge-text-color);
      }
    }
  }
  .icon {
    font-size: 1em;
    transition: ease-in-out transform .2s;
  }
}
.pulse {
  animation-name: bounce;
  animation-duration: 1s;
  animation-iteration-count: 1;
}
@keyframes bounce {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1) }
}
</style>
